/**
 * Image URL helpers (2026-02-20).
 *
 * The backend stores menu item images as relative paths like
 *   "/api/menu/images/{file_id}"
 * so the URL is portable across environments (preview ↔ production).
 *
 * Frontend code that renders an `<img src={...}>` should run the URL
 * through `menuImageSrc()` so relative paths get prefixed with
 * REACT_APP_BACKEND_URL while external URLs (http/https) pass through
 * unchanged. Object URLs (`blob:`) also pass through unchanged for the
 * pending-upload preview in create-mode.
 */
import { API } from "@/lib/api";

const BACKEND_BASE = API.replace(/\/api$/, "");

export function menuImageSrc(url) {
  if (!url) return null;
  if (/^(https?:|blob:|data:)/i.test(url)) return url;
  // Relative — prepend the API origin.
  return `${BACKEND_BASE}${url.startsWith("/") ? "" : "/"}${url}`;
}

/**
 * Pick the smallest URL that's good enough for a given context.
 * Returns the thumb URL when available + when the consumer is a small
 * card; otherwise returns the display URL.
 */
export function menuImagePreferredSrc({ image_url, image_thumb_url } = {},
                                       { prefer = "thumb" } = {}) {
  const primary = prefer === "thumb"
    ? (image_thumb_url || image_url)
    : (image_url || image_thumb_url);
  return menuImageSrc(primary);
}
